/**
 * Vue全局应用
 */

import Vue from 'vue'
import statistic from './statistic'
import commonMethods from './commonMethods'
import MtaH5 from 'mta-h5-analysis'
import axios from './axios'
import modal from './modal'
import style from '@v2/static/client/style'

Vue.prototype.MtaH5 = MtaH5
Vue.prototype.$http = axios
Vue.prototype.addRecord = statistic.addRecord
Vue.prototype.addMtaEvent = statistic.addMtaEvent
Vue.prototype.pushH5Msg = commonMethods.pushH5Msg
Vue.prototype.$modal = modal
Vue.prototype.$style = style
Vue.prototype.$platformId = global.PLATFORMID



// WEBPACK FOOTER //
// ./src/v2/static/js/globalProto.js